import React from "react"
import ReactCanvasConfetti from "react-canvas-confetti"

const canvasStyles = {
    position: "fixed",
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    zIndex: 1000,
}

export default class SchoolPride extends React.Component {
    constructor(props) {
        super(props)
        this.isAnimationEnabled = false
        this.animationInstance = null
        this.nextTickAnimation = this.nextTickAnimation.bind(this)
    }

    makeShot = (angle, originX) => {
        this.animationInstance &&
            this.animationInstance({
                particleCount: 3,
                angle,
                spread: 55,
                origin: { x: originX },
                colors: ["#bb0000", "#ffffff"],
            })
    }

    nextTickAnimation = () => {
        this.makeShot(60, 0)
        this.makeShot(120, 1)
        if (this.isAnimationEnabled)
            requestAnimationFrame(this.nextTickAnimation)
    }

    startAnimation = () => {
        if (!this.isAnimationEnabled) {
            this.isAnimationEnabled = true
            this.nextTickAnimation()
        }
    }

    pauseAnimation = () => {
        this.isAnimationEnabled = false
    }

    stopAnimation = () => {
        this.isAnimationEnabled = false
        this.animationInstance && this.animationInstance.reset()
    }

    getInstance = (instance) => {
        this.animationInstance = instance
    }

    componentDidMount() {
        this.startAnimation()
        setTimeout(() => {
            this.pauseAnimation()
        }, 1000)
    }

    componentWillUnmount() {
        this.isAnimationEnabled = false
    }

    render() {
        return (
                <ReactCanvasConfetti
                    refConfetti={this.getInstance}
                    style={canvasStyles}
                />
        )
    }
}
